import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-app-features-fold',
    templateUrl: './app-features-fold.component.html',
    styleUrls: ['./app-features-fold.component.scss'],
    standalone: false
})
export class AppFeaturesFoldComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
